import { NavLink, useLocation, useNavigate } from 'react-router';

import { ROUTES } from '@/app/router/routes';
import { Logo } from '@/components/brand/Logo';
import { InboxIcon } from '@/components/icons';
import { useUnreadCount } from '@/features/messages/useMessages';
import { useAuth } from '@/features/auth/context/auth-context';

import { HeaderSearch } from './HeaderSearch';
import { UserMenu } from './UserMenu';
import './Header.css';

export const Header = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const unread = useUnreadCount();
  const messagesLabel =
    unread > 0 ? `Mes messages — ${unread} non lu${unread > 1 ? 's' : ''}` : 'Mes messages';
  const handleLogout = () => {
    void logout().then(() => navigate(ROUTES.login, { replace: true }));
  };

  return (
    <header className="platform-header">
      <div className="platform-header-surface">
        <NavLink
          to={ROUTES.timesheets}
          aria-label="ubeefy — Accueil"
          className="platform-header-brand"
        >
          <Logo />
        </NavLink>
        <HeaderSearch key={location.key} />
        <div className="platform-header-account">
          <NavLink
            to={ROUTES.messages}
            className="platform-header-messages"
            title={messagesLabel}
            aria-label={messagesLabel}
          >
            <InboxIcon aria-hidden />
            {unread > 0 && (
              <span className="platform-header-messages__badge" aria-hidden>
                {unread > 99 ? '99+' : unread}
              </span>
            )}
          </NavLink>
          {user ? <UserMenu user={user} onLogout={handleLogout} /> : null}
        </div>
      </div>
    </header>
  );
};
